import { NgModule } from '@angular/core';
import { AfBrandLogoDirective } from './af-brand-logo.directive';
import { AfItemStatusDirective } from './af-item-status-icon.directive';

@NgModule({
  declarations: [
    AfBrandLogoDirective,
    AfItemStatusDirective
  ],
  exports: [AfBrandLogoDirective, AfItemStatusDirective]
})
export class AfDirectiveModule { }